(() => {
  angular
    .module('gm.common.directives')
    .directive('gmLineInput', gmLineInputDirective);

  function gmLineInputDirective() {
    'ngInject';

    const LINE_INPUT_ACTIVE_CLASS = 'line-input--active';
    const LINE_INPUT_FOCUS_CLASS = 'line-input--focus';
    const LINE_INPUT_BLOCK_SELECTOR = '.line-input';

    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, element, _attrs, ctrl) {
        const blockEl = element.closest(LINE_INPUT_BLOCK_SELECTOR);

        function _onChange(val, isFocus) {
          if (isFocus) {
            blockEl.addClass(LINE_INPUT_FOCUS_CLASS);
          } else {
            blockEl.removeClass(LINE_INPUT_FOCUS_CLASS);
          }

          if (isFocus || val) {
            blockEl.addClass(LINE_INPUT_ACTIVE_CLASS);
          } else {
            blockEl.removeClass(LINE_INPUT_ACTIVE_CLASS);
          }
        }

        element.on('focus', () => _onChange(ctrl.$viewValue, true))
          .on('blur', () => _onChange(ctrl.$viewValue, false));

        scope.$watch(() => ctrl.$viewValue, val => _onChange(val, element.is(':focus')));
      }
    };
  }
})();
